module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"work":"Work","workers":"Workers"},"ja":{"work":"転職したい","workers":"採用したい"}}')
  delete Component.options._Ctor
}
